import { render, staticRenderFns } from "./ChangePicture.vue?vue&type=template&id=6178f05c&"
import script from "./ChangePicture.vue?vue&type=script&lang=js&"
export * from "./ChangePicture.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports